import { IAssetComponent } from "@framework/types";

import { TokenDepositInput } from "../../../../../inputs/deposit-token";

export interface IStakingDepositDto {
  tokenIds: Array<number>;
  deposit: IAssetComponent[];
}

export const StakingDepositDialog = () => {
  return <TokenDepositInput />;
};
